import { render, staticRenderFns } from "./JdsReactionPanel.vue?vue&type=template&id=b4a393d6&scoped=true&"
import script from "./JdsReactionPanel.vue?vue&type=script&lang=ts&"
export * from "./JdsReactionPanel.vue?vue&type=script&lang=ts&"
import style0 from "./JdsReactionPanel.vue?vue&type=style&index=0&id=b4a393d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a393d6",
  null
  
)

export default component.exports